import React from 'react';
import { FadeInSection } from './ui/FadeInSection';
import { CTAButton } from './ui/CTAButton';
import { Check, ShieldCheck, Lock, Smartphone } from 'lucide-react';
export function OfferBreakdown() {
  const tomos = [{
    emoji: '📕',
    title: 'TOMO 01 — RESCATE 180 SEGUNDOS',
    value: '$4.990',
    bullets: ['12 recetas listas en 3 minutos.', 'La técnica del "Interruptor Proteico".', 'El mugcake que frena el antojo en 180 segundos.']
  }, {
    emoji: '📗',
    title: 'TOMO 02 — DULCES CERO CULPA ARGENTINA',
    value: '$4.990',
    bullets: ['Alfajor proteico, chocotorta fit, flan de vainilla y medialunas fit.', '25+ clásicos argentinos adaptados al Método.', 'Sin que nadie note la diferencia.']
  }, {
    emoji: '📘',
    title: 'TOMO 03 — CREMAS, HELADOS Y MOUSSES',
    value: '$4.990',
    bullets: ['Helado de chocolate con 3 ingredientes.', 'Mousse de dulce de leche en 5 minutos.', 'Paletas proteicas para tener en el freezer.']
  }, {
    emoji: '📙',
    title: 'TOMO 04 — PANADERÍA FIT & WHEY',
    value: '$4.990',
    bullets: ['Banana bread, muffins, brownies y cookies proteicas.', 'Pancakes para el desayuno del domingo.', 'El olor a recién horneado sin el pico de glucosa.']
  }, {
    emoji: '🏆',
    title: 'TOMO 05 — EL PROTOCOLO MAESTRO',
    value: '$6.990',
    bullets: ['El mecanismo del antojo explicado de una vez para siempre.', 'Planificador semanal de "Dulces Estratégicos".', 'El mapa completo para los primeros 21 días.', 'Sin este tomo tenés recetas. Con este tomo tenés un Sistema.'],
    highlight: true
  }];
  const bonos = [{
    emoji: '🟣',
    title: 'BONO 01 — KIT RESCATE 11:11',
    value: '$2.990',
    bullets: ['7 recetas nocturnas en 5 minutos.', 'Tracker de 7 días de progreso.', 'Qué hacer exactamente a las 11pm.']
  }, {
    emoji: '🟢',
    title: 'BONO 02 — PLANTILLAS DE COMPRA',
    value: '$1.990',
    bullets: ['Lista semanal lista para usar.', 'Marcas argentinas con mejor relación calidad-precio.', 'Mapa de góndola para Carrefour, Coto y Disco.']
  }, {
    emoji: '🔴',
    title: 'BONO 03 — ANTI-GRUMOS & TEXTURA',
    value: '$1.990',
    bullets: ['Por qué la proteína se pone gomosa y cómo evitarlo.', 'Temperaturas exactas por preparación.', 'Tabla de sustituciones completa.']
  }, {
    emoji: '⚪',
    title: 'BONO 04 — HELADERA & FREEZER BLINDADOS',
    value: '$1.990',
    bullets: ['Qué preparar el domingo para 7 días resueltos.', 'Sistema de etiquetado por colores.', 'El "Tupper de Emergencia" para el trabajo.']
  }, {
    emoji: '🩶',
    title: 'BONO 05 — SCRIPTS & COPYS LISTOS',
    value: '$1.990',
    bullets: ['Qué decirle a tu familia.', 'Cómo manejarte en asados y reuniones.', 'Cómo decir "no" sin culpa.']
  }];
  return <>
      {/* SECTION 9 — OFFER PRESENTATION */}
      <section className="bg-chocolate text-center px-4 py-16 md:py-24" data-id="element-90">
        <div className="max-w-3xl mx-auto" data-id="element-91">
          <FadeInSection data-id="element-92">
            <p className="text-gold tracking-widest text-sm font-bold mb-4" data-id="element-93">
              PRESENTAMOS
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gold mb-2" data-id="element-94">
              MÉTODO ANTÍDOTO DULCE
            </h2>
            <p className="text-2xl md:text-3xl text-warmWhite font-heading italic mb-12" data-id="element-95">
              SISTEMA COMPLETO
            </p>

            <img src="https://cdn.magicpatterns.com/uploads/vVtmQXAzTB3twVeUuMKgza/Mockup.png" alt="Sistema Completo Mockup" className="w-full max-w-md mx-auto h-auto drop-shadow-2xl mb-12" data-id="element-96" />

            <p className="text-xl md:text-2xl text-cream font-medium mb-4" data-id="element-97">
              El primer sistema de nutrición diseñado para la mujer argentina
              que no quiere dejar de comer dulce.
            </p>
            <p className="text-gold-light font-bold text-lg" data-id="element-98">
              500+ páginas de entrenamiento nutricional.
            </p>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 10 — VALUE BREAKDOWN */}
      <section className="bg-cream px-4 py-16 md:py-24" data-id="element-99">
        <div className="max-w-3xl mx-auto" data-id="element-100">
          <FadeInSection data-id="element-101">
            <div className="space-y-6 mb-16" data-id="element-102">
              {tomos.map((tomo, idx) => <div key={idx} className={`p-6 md:p-8 rounded-2xl shadow-warm border border-gold/20 ${tomo.highlight ? 'bg-gold/5 border-gold shadow-gold' : 'bg-warmWhite'}`} data-id="element-103">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 border-b border-gold/15 pb-4" data-id="element-104">
                    <h4 className="text-lg md:text-xl font-bold text-chocolate flex items-center gap-3" data-id="element-105">
                      <span className="text-2xl" data-id="element-106">{tomo.emoji}</span>
                      {tomo.title}
                    </h4>
                    <span className="text-sm font-bold text-chocolate bg-gold/15 px-3 py-1 rounded-full whitespace-nowrap border border-gold/20" data-id="element-107">
                      Valor: {tomo.value}
                    </span>
                  </div>
                  <ul className="space-y-3" data-id="element-108">
                    {tomo.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-109">
                        <Check className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-110" />
                        <span className={`text-textBody ${bIdx === tomo.bullets.length - 1 && tomo.highlight ? 'font-bold text-chocolate' : ''}`} data-id="element-111">
                          {bullet}
                        </span>
                      </li>)}
                  </ul>
                </div>)}
            </div>

            <div className="flex items-center gap-4 mb-12" data-id="element-112">
              <div className="flex-1 h-px bg-gold/30" data-id="element-113"></div>
              <h3 className="text-2xl font-bold text-chocolate italic" data-id="element-114">
                Y además... los 5 bonos:
              </h3>
              <div className="flex-1 h-px bg-gold/30" data-id="element-115"></div>
            </div>

            <div className="space-y-6" data-id="element-116">
              {bonos.map((bono, idx) => <div key={idx} className="bg-warmWhite p-6 md:p-8 rounded-2xl shadow-sm border border-gold/20 relative overflow-hidden" data-id="element-117">
                  <div className="absolute top-0 right-0 bg-urgency text-white text-xs font-bold px-4 py-1 rounded-bl-lg" data-id="element-118">
                    GRATIS HOY
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 border-b border-gold/10 pb-4 pr-20 sm:pr-0" data-id="element-119">
                    <h4 className="text-lg md:text-xl font-bold text-chocolate flex items-center gap-3" data-id="element-120">
                      <span className="text-2xl" data-id="element-121">{bono.emoji}</span>
                      {bono.title}
                    </h4>
                    <span className="text-sm font-medium text-chocolate-light line-through hidden sm:block" data-id="element-122">
                      Valor: {bono.value}
                    </span>
                  </div>
                  <ul className="space-y-3" data-id="element-123">
                    {bono.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-124">
                        <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-125" />
                        <span className="text-textBody" data-id="element-126">{bullet}</span>
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 11 — OFFER STACK TABLE */}
      <section className="bg-warmWhite px-4 py-16" data-id="element-127">
        <div className="max-w-2xl mx-auto" data-id="element-128">
          <FadeInSection data-id="element-129">
            <div className="bg-white rounded-3xl shadow-warm border border-cream-dark overflow-hidden" data-id="element-130">
              <div className="p-6 md:p-8 bg-chocolate text-gold text-center" data-id="element-131">
                <h3 className="text-2xl font-bold" data-id="element-132">RESUMEN DE TU INVERSIÓN</h3>
              </div>
              <div className="p-6 md:p-8" data-id="element-133">
                <div className="space-y-3 mb-6" data-id="element-134">
                  {[{
                  name: 'Tomo 01',
                  val: '$4.990'
                }, {
                  name: 'Tomo 02',
                  val: '$4.990'
                }, {
                  name: 'Tomo 03',
                  val: '$4.990'
                }, {
                  name: 'Tomo 04',
                  val: '$4.990'
                }, {
                  name: 'Tomo 05',
                  val: '$6.990'
                }, {
                  name: 'Bono 01',
                  val: '$2.990'
                }, {
                  name: 'Bono 02',
                  val: '$1.990'
                }, {
                  name: 'Bono 03',
                  val: '$1.990'
                }, {
                  name: 'Bono 04',
                  val: '$1.990'
                }, {
                  name: 'Bono 05',
                  val: '$1.990'
                }].map((item, idx) => <div key={idx} className="flex justify-between items-center text-textBody border-b border-cream-dark pb-2 last:border-0" data-id="element-135">
                      <span data-id="element-136">{item.name}</span>
                      <span className="font-medium" data-id="element-137">{item.val}</span>
                    </div>)}
                </div>

                <div className="flex justify-between items-center text-chocolate-light mb-4" data-id="element-138">
                  <span className="font-bold" data-id="element-139">VALOR TOTAL</span>
                  <span className="line-through text-lg" data-id="element-140">$37.900</span>
                </div>

                <div className="bg-cream-dark p-4 rounded-xl flex flex-col sm:flex-row justify-between items-center gap-2 border border-gold/30" data-id="element-141">
                  <span className="font-bold text-chocolate text-lg" data-id="element-142">
                    🔥 TU INVERSIÓN HOY
                  </span>
                  <span className="text-3xl md:text-4xl font-black text-gold drop-shadow-sm" data-id="element-143">
                    $19.990
                  </span>
                </div>

                <div className="text-center mt-6" data-id="element-144">
                  <p className="text-success font-bold text-lg" data-id="element-145">
                    Ahorrás $17.910 hoy.
                  </p>
                  <p className="text-textBody text-sm" data-id="element-146">
                    47% del valor real del Sistema.
                  </p>
                </div>
              </div>
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 12 — CTA #1 */}
      <section className="bg-chocolate text-center px-4 py-16 relative" data-id="element-147">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gold/10 via-chocolate to-chocolate" data-id="element-148"></div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-149">
          <FadeInSection data-id="element-150">
            <CTAButton className="w-full md:w-auto text-xl md:text-2xl px-12 py-6 mb-4" data-id="element-151">
              🔥 QUIERO EL SISTEMA COMPLETO
            </CTAButton>
            <p className="text-gold-light text-lg mb-8" data-id="element-152">
              Acceder ahora por $19.990
            </p>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-cream text-sm md:text-base font-medium" data-id="element-153">
              <div className="flex items-center gap-2" data-id="element-154">
                <Check className="w-5 h-5 text-gold" data-id="element-155" /> Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-156">
                <ShieldCheck className="w-5 h-5 text-gold" data-id="element-157" /> Garantía 7 días
              </div>
              <div className="flex items-center gap-2" data-id="element-158">
                <Lock className="w-5 h-5 text-gold" data-id="element-159" /> Sin suscripciones
              </div>
              <div className="flex items-center gap-2" data-id="element-160">
                <Smartphone className="w-5 h-5 text-gold" data-id="element-161" /> Acceso de por vida
              </div>
            </div>
          </FadeInSection>
        </div>
      </section>
    </>;
}